import { gql } from '@apollo/client';

import client from '../../../../core/services/graphql';

const GET_PROJECT_QUESTIONS = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      description
      testType
      status
      studyContext
      segments{
        device
      }
      surveys {
        id
        surveyType
        questions {
          id
          label
          questionType
          questionOrder
          groupId
          leftLabel
          rightLabel
          blurVideo
          imageKey
          imageUrl
          videoKey
          videoUrl
          randomize
          questionOptions(preserveOrder: true) {
            id
            label
          }
        }
        surveysPages {
          id
          pageName
          order
          questions {
            id
            label
            questionType
            groupId
            questionOrder
            leftLabel
            rightLabel
            blurVideo
            randomize
            displayTime
            questionOptions {
              id
              label
              imageKey
              imageUrl
              matrixOption
            }
          }
        }
      }
    }
  }
`;

export const getProjectQuestions = async (projectId) => {
  const { data } = await client.getClient().query({
    query: GET_PROJECT_QUESTIONS,
    variables: { id: projectId },
  });

  return data;
};
